import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { SITE } from "../data/site";

const links = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Products" },
  { to: "/about", label: "About" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar({ variant = "light" }) {
  const [open, setOpen] = useState(false);
  const dark = variant === "dark";

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-40 ${
        dark ? "bg-transparent" : "bg-[#FDFBF7]/85 backdrop-blur border-b border-[rgba(107,31,34,0.1)]"
      }`}
    >
      <div className="container-edge flex items-center justify-between py-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className={`w-10 h-10 grid place-items-center border ${dark ? "border-white/40" : "border-[var(--maroon-700)]"}`}>
            <span className={`font-display text-lg ${dark ? "text-white" : "text-[var(--maroon-900)]"}`}>P</span>
          </div>
          <div className="leading-tight hidden sm:block">
            <div className={`font-display text-lg ${dark ? "text-white" : "text-[var(--maroon-950)]"}`}>{SITE.brand}</div>
            <div className={`text-[10px] tracking-[0.22em] uppercase ${dark ? "text-white/70" : "text-[var(--maroon-700)]"} font-mono-accent`}>
              Est. {SITE.established} · Patiala
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${
                  dark
                    ? `text-white/80 hover:text-white ${isActive ? "text-white" : ""}`
                    : `text-[var(--text-secondary)] hover:text-[var(--maroon-900)] ${isActive ? "text-[var(--maroon-900)]" : ""}`
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" className="btn-primary" data-testid="nav-cta-quote">
            Request a Quote
          </Link>
        </nav>

        <button
          data-testid="nav-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden p-2 ${dark ? "text-white" : "text-[var(--maroon-900)]"}`}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[rgba(107,31,34,0.12)] bg-[#FDFBF7]">
          <div className="container-edge py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                onClick={() => setOpen(false)}
                className="text-[var(--text-primary)] py-2 border-b border-[rgba(107,31,34,0.08)]"
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)} className="btn-primary mt-2" data-testid="nav-mobile-cta-quote">
              Request a Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
